<template>
  <!-- The person's own menu, behind their name: where the main menu sits, and
       logging out. Hiding the menu is the button on the menu itself. The choice is theirs alone and is saved on
       the server, so it follows them to every device. -->
  <v-menu v-model="open" :location="location" :offset="8" :close-on-content-click="false">
    <template #activator="{ props }">
      <slot name="activator" :props="props" :open="open" :initials="initials" :fullName="name" :role="role" />
    </template>
    <section class="frame-pop frame-profile" role="dialog" aria-label="Minu menüü">
      <div class="frame-profile__head">
        <span class="frame-avatar" aria-hidden="true">{{ initials }}</span>
        <span class="frame-profile__who">
          <span class="frame-profile__name">{{ name }}</span>
          <span class="frame-profile__role">{{ role }}</span>
        </span>
        <button class="frame-icon-btn" type="button" aria-label="Sulge" @click="open = false">
          <v-icon size="20">mdi-close</v-icon>
        </button>
      </div>

      <div class="d-flex flex-column ga-2">
        <span id="frame-position-label" class="frame-profile__label">Menüü asukoht</span>
        <div class="frame-seg" role="group" aria-labelledby="frame-position-label">
          <button
            v-for="option in positions"
            :key="option.value"
            type="button"
            :aria-pressed="String(layout.position === option.value)"
            @click="choose(option.value)"
          >
            <span class="frame-seg__pic" :class="'frame-seg__pic--' + option.value"><i /></span>
            {{ option.text }}
          </button>
        </div>
      </div>

      <span class="frame-profile__note">
        {{ mobile ? 'Telefonis on menüü alati ☰ nupu taga; siin valitu kehtib suuremal ekraanil.' : 'Valik jääb sinu kasutajale meelde ja kehtib igas seadmes.' }}
      </span>

      <div class="frame-profile__foot">
        <router-link to="/me" @click="open = false">Minu seaded</router-link>
        <a href="/auth/logout">Logi välja</a>
      </div>
    </section>
  </v-menu>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { initials, roleLabel } from './frameLinks'

const POSITIONS = [
  { value: 'left', text: 'Vasakul' },
  { value: 'right', text: 'Paremal' },
  { value: 'top', text: 'Üleval' }
]

export default {
  props: {
    location: { type: String, default: 'top' },
    mobile: { type: Boolean, default: false }
  },
  data () {
    return { open: false }
  },
  computed: {
    ...mapState(['user', 'layout']),
    positions: () => POSITIONS,
    name () {
      return (this.user && this.user.fullName) || ''
    },
    initials () {
      return initials(this.name)
    },
    role () {
      return roleLabel(this.user && this.user.roles)
    }
  },
  methods: {
    ...mapActions(['saveLayout']),
    choose (position) {
      if (position !== this.layout.position) this.saveLayout({ position })
    }
  }
}
</script>
